/**
 * Visible breadcrumb — mirrors the JSON-LD BreadcrumbList emitted by
 * the same page's `+data.ts`. Use logical CSS properties so RTL
 * (Arabic) reads correctly without a CSS override.
 */

type Crumb = {
  name: string;
  /** path with leading slash; omit on the current page (last crumb) */
  href?: string;
};

type Props = {
  items: Crumb[];
  locale?: string;
};

export function Breadcrumb({ items, locale }: Props) {
  if (items.length === 0) return null;
  const localePrefix = locale && locale !== "en" ? `/${locale}` : "";
  return (
    <nav
      aria-label="Breadcrumb"
      className="text-sm text-muted-foreground ps-0 pe-0 py-2"
    >
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          const href = item.href ? `${localePrefix}${item.href}` : undefined;
          return (
            <li key={`${item.name}-${i}`} className="flex items-center gap-1.5">
              {href && !isLast ? (
                <a href={href} className="hover:underline">
                  {item.name}
                </a>
              ) : (
                <span aria-current={isLast ? "page" : undefined}>{item.name}</span>
              )}
              {!isLast && (
                <span aria-hidden="true" className="text-muted-foreground/60">
                  /
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
